/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Include_MetadataInputs */



/**
* | output |
* | --- |
* | "Include Metadata" |
*
* @param {Transcript_Export_Include_MetadataInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_include_metadata = /** @type {((inputs?: Transcript_Export_Include_MetadataInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Include_MetadataInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inclure les metadonnees")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadaten einbeziehen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Includi metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить метаданные")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incluir metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("包含元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータを含める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा शामिल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incluir metadados")
	return /** @type {LocalizedString} */ ("Include Metadata")
});